import { updateField } from 'vuex-map-fields';
import types from './mutations-types';

const mutations = {
  updateField,
  [types.SET_COMPANY](state, payload) {
    state.company = {
      ...state.company,
      ...payload,
    };
  },
  [types.SET_BRAND_ACTIONS](state, payload) {
    state.brandActions = payload;
  },
  [types.SET_WORD_CLOUD](state, payload) {
    state.wordcloud = payload;
  },
  [types.SET_METRIC](state, payload) {
    state.myMetric = payload;
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/companies/mutations.js